import { render, staticRenderFns } from "./EditWhatsappGroup.vue?vue&type=template&id=b678af66"
import script from "./EditWhatsappGroup.vue?vue&type=script&lang=js"
export * from "./EditWhatsappGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports